import React from "react";
import CheckBox from "../../../../../../../_components/Checkbox";
import { getNFeConfig, updateNFeConfig } from "../../../../../../../api/nfe";
import Text from "../../../../../../../_components/Text";

export default (props) => {
  const [loading, setLoading] = React.useState(false);
  const [config, setConfig] = React.useState({});
  const [manageStock, setManageStock] = React.useState(false);
  const ref = React.useRef(null);

  const onChangeState = () => {
    const newValue = !manageStock;
    setManageStock(newValue);

    setTimeout(() => {
      setLoading(true);
      updateNFeConfig({
        ...config,
        manage_stock: newValue,
      })
        .then((data) => {
          setConfig(data);
        })
        .finally(() => {
          setTimeout(() => {
            setLoading(false);
          }, 500);
        });
    }, 250);
  };

  React.useEffect(() => {
    setLoading(true);
    getNFeConfig()
      .then((data) => {
        setConfig(data);
        setManageStock(data.manage_stock);
      })
      .catch((error) => {})
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [ref.current]);
  return (
    <div className="my-3" ref={ref}>
      {loading ? (
        <Text>
          <i className="fas fa-spinner fa-pulse"></i> Atualizando ...
        </Text>
      ) : (
        <CheckBox
          onClick={onChangeState}
          checked={manageStock}
          label="Movimentar Estoque"
        />
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Identification/Details/ManageStock/index.jsx